<template>
    <div :class="styleClass || ''">
        <div class="input-group date" :class="disabled ? 'datetimepicker-input-append-disabled' : ''" :id="elementId" data-target-input="nearest">
            <div class="input-group-prepend" :data-target="`#${elementId}`" data-toggle="datetimepicker" style="flex: 0;">
                <div class="input-group-text"><i class="far fa-calendar-alt" :class="disabled ? 'icon-disabled' : ''"></i></div>
            </div>
            <input type="text"
                   :disabled="disabled ? disabled : false"
                   autocomplete="off"
                   :id="`${elementId}-input`"
                   class="form-control datetimepicker-input clickable"
                   :class="inputClass || ''"
                   :data-target="`#${elementId}`"
                   readonly="readonly"
                   :placeholder="placeholder"
                   :style="disabled ? '' : 'background-color: initial;'"
                   @click.prevent="toggleDatepicker" />
            <div v-if="clearButton && disabled !== true" class="input-group-append" style="flex: 0;" :title="trans('common.actions.clear')">
                <div class="input-group-text clickable" @click.prevent="clearInput">
                    <i class="fa fa-trash-alt" :class="disabled ? 'icon-disabled' : ''"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import momentTz from 'moment-timezone';

    import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css';

    export default {
        name: 'timepicker',

        props: [
            'id',
            'selected',
            'disabled',
            'minDate',
            'styleClass',
            'inputClass',
            'minuteInterval',
            'viewMode',
            'clearButton',
            'placeholder'
        ],

        data() {
            return {
                // ID is used for data-target, fallback to random string
                elementId: this.id || Math.random().toString(36).substring(2, 15),
                format: 'DD/MMM/YY'
            };
        },

        mounted() {
            this.mount(this.selected);
        },

        methods: {

            mount(selected) {
                this.$nextTick(() => {
                    const timePicker = $(`#${this.elementId}`);

                    // Set start of week to monday
                    moment.updateLocale(moment.locale(), {
                        week: {
                            dow: 1
                        }
                    });

                    const options = {
                        locale: moment.locale(),
                        useCurrent: false,
                        ignoreReadonly: true,
                        tooltips: {
                            today: this.trans('plugins.datetimepicker.today'),
                            clear: this.trans('plugins.datetimepicker.clear'),
                            close: this.trans('plugins.datetimepicker.close'),
                            selectMonth: this.trans('plugins.datetimepicker.select_month'),
                            prevMonth: this.trans('plugins.datetimepicker.previous_month'),
                            nextMonth: this.trans('plugins.datetimepicker.next_month'),
                            selectYear: this.trans('plugins.datetimepicker.select_year'),
                            prevYear: this.trans('plugins.datetimepicker.previous_year'),
                            nextYear: this.trans('plugins.datetimepicker.next_year'),
                            selectDecade: this.trans('plugins.datetimepicker.select_decade'),
                            prevDecade: this.trans('plugins.datetimepicker.previous_decade'),
                            nextDecade: this.trans('plugins.datetimepicker.next_decade'),
                            prevCentury: this.trans('plugins.datetimepicker.previous_century'),
                            nextCentury: this.trans('plugins.datetimepicker.next_century'),
                            incrementHour: this.trans('plugins.datetimepicker.increment_hour'),
                            pickHour: this.trans('plugins.datetimepicker.pick_hour'),
                            decrementHour: this.trans('plugins.datetimepicker.decrement_hour'),
                            incrementMinute: this.trans('plugins.datetimepicker.increment_minute'),
                            pickMinute: this.trans('plugins.datetimepicker.pick_minute'),
                            decrementMinute: this.trans('plugins.datetimepicker.decrement_minute'),
                            incrementSecond: this.trans('plugins.datetimepicker.increment_second'),
                            pickSecond: this.trans('plugins.datetimepicker.pick_second'),
                            decrementSecond: this.trans('plugins.datetimepicker.decrement_second')
                        }
                    };

                    if (selected) {
                        options.defaultDate = momentTz(selected);
                    }

                    if (this.minDate) {
                        options.minDate = momentTz(this.minDate);
                    }

                    if (this.viewMode && this.viewMode) {
                        options.viewMode = this.viewMode;

                        if (this.viewMode === 'months') {
                            this.format = 'MM/YYYY';
                        } else {
                            this.format = 'YYYY';
                        }
                    }

                    options.format = this.format;

                    timePicker.datetimepicker(options);

                    const self = this;

                    // If timepicker is inside a modal dialog, make sure toggle works
                    if ($(this.$el).parents('.modal-content').length) {
                        $(this.$el).find('.input-group-prepend').on('click', function () {
                            self.toggleDatepicker();
                        });
                    }

                    timePicker.on('change.datetimepicker datetimepicker.change', function () {
                        // Emit on change if picker is not open
                        if (!$(self.$el).find('.bootstrap-datetimepicker-widget').length) {
                            self.emitChanges();
                        }
                    });

                    timePicker.on('hide.datetimepicker datetimepicker.hide', function () {
                        // Emit on closing picker
                        self.emitChanges();
                    });
                });
            },

            toggleDatepicker() {
                $(`#${this.elementId}`).datetimepicker('toggle');
            },

            clearInput() {
                const timePicker = $(`#${this.elementId}`);

                $(`#${this.elementId}-input`).val(null);
                timePicker.datetimepicker('clear');
                this.emitChanges();

                // destroy and reinitialize to avoid tempusdominus errors
                // see: https://github.com/tempusdominus/bootstrap-4/issues/34
                timePicker.datetimepicker('destroy');
                this.mount(null);
            },

            emitChanges() {
                const textInput = $(`#${this.elementId}-input`).val();

                if ((!textInput || textInput === '')) {
                    this.$emit('update', null);
                } else {
                    const moment = $(`#${this.elementId}`).datetimepicker('viewDate');
                    const selected = this.selected ? momentTz(this.selected).format('YYYY-MM-DD') : null;

                    if (moment.format('YYYY-MM-DD') !== selected) {
                        this.$emit('update', moment.format('YYYY-MM-DD'));
                    }
                }
            }
        },

        watch: {
            selected: function (value) {
                if (value === null) {
                    const timePicker = $(`#${this.elementId}`);

                    $(`#${this.elementId}-input`).val(null);
                    timePicker.datetimepicker('clear');

                    timePicker.datetimepicker('destroy');
                    this.mount(null);
                } else {
                    $(`#${this.elementId}-input`).val(momentTz(value).format(this.format));
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/DateTimepicker/Datepicker.vue